import type { ButtonConfig } from '../declare'
import * as Header from './header'
import { $consts } from 'src/plugins'

/**
 * 竖树表单弹框类型按钮
 * @param props 
 * @returns 
 */
const HeaderButton = (props: { config: ButtonConfig }) => {
  const { BTN_TYPE } = props.config
  switch (BTN_TYPE) {
    // 新增同级按钮
    case $consts['TABLE/BTN_TYPE_TREE_SAMELEVEL_ADD']:
      return <Header.AddBtnSameLevel config={props.config} />
    // 新增下级按钮
    case $consts['TABLE/BTN_TYPE_ADD']:
      return <Header.AddBtnDiffLevel config={props.config} />
    // 删除按钮
    case $consts['TABLE/BTN_TYPE_DELETE']:
      return <Header.DeleteConfirmBtn config={props.config} />
    // 编辑按钮
    case $consts['TABLE/BTN_TYPE_EDIT_PAGE']:
      return <Header.EditModalBtn config={props.config} />
    default:
      return <div />
  }
}

export default HeaderButton
